import { render } from "./BoardComponent.vue?vue&type=template&id=3cdc1b6e&scoped=true"
import script from "./BoardComponent.vue?vue&type=script&lang=js"
export * from "./BoardComponent.vue?vue&type=script&lang=js"

import "./BoardComponent.vue?vue&type=style&index=0&id=3cdc1b6e&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cdc1b6e"]])

export default __exports__